export type ArticleCarouselFooterProps = {
  caption: string;
  credit: string;
};

export default function ArticleCarouselFooter({
  caption,
  credit,
}: ArticleCarouselFooterProps) {
  return (
    <div
      className="inline-flex gap-2 items-center w-full bg-white-200 p-[10px]"
      data-testid="image-caption-wrapper"
    >
      <span className="w-full font-regular text-black-800 font-primary text-xxs leading-[150%]">
        {`${caption} - `} <span className="font-medium">{credit}</span>
      </span>
    </div>
  );
}
